
<template>
    <svg v-if="name">                
        <use :xlink:href="svgIconHref" :href="svgIconHref"></use>
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        name: String
    },
    data: function() {
        return {
        }
    },
    computed: {
        svgIconHref() {
            if (this.name) {
                return require('@/assets/icons.svg') + '#' + this.name;
            } else {
                return '';
            }
        }
    }
}
</script>
